import React from 'react';

const Card = ({
  children,
  grid,
  image,
}) => {
  const c = (
    <div className="card">
      <div className="card-body">
        <div>
          {children}
        </div>
      </div>
    </div>
  );
  const g = ({
    lg: 'col',
    md: 'col-md-9 col-lg-8 col-xl-7',
    sm: 'col-md-8 col-lg-6 col-xl-5',
  })[grid] || grid;

  return grid ? (
    <div className="container">
      <div className="row align-items-center">
        {image && (
          <div className="col-12 col-lg order-lg-1">
            <img
              alt="all mascots"
              className="img-fluid"
              src={image}
            />
          </div>
        )}
        <div className={g}>
          {c}
        </div>
      </div>
    </div>
  ) : c;
};

export default Card;
